import { createSelector } from 'reselect';

import { getCoworkingFlexWorkplaceSelector } from 'shared/store/coworking/selectors/dump/getCoworkingFlexWorkplaceSelector';

export const coworkingFlexibleWorkplaceWithErrorSelector = createSelector(
  getCoworkingFlexWorkplaceSelector,
  flexible => {
    if (flexible) {
      return flexible;
    }

    throw new Error('coworkingFlexibleWorkplaceWithErrorSelector Незакреплённый офис не найден в сторе');
  },
);
